import { render, staticRenderFns } from "./BaseForm.vue?vue&type=template&id=196ac88e&scoped=true&"
import script from "./BaseForm.vue?vue&type=script&lang=ts&"
export * from "./BaseForm.vue?vue&type=script&lang=ts&"
import style0 from "./BaseForm.vue?vue&type=style&index=0&id=196ac88e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196ac88e",
  null
  
)

export default component.exports